// @ts-nocheck
import { UseFormReturnType } from '@mantine/form';

import { GuestFields } from '@/entities/GuestFields/GuestFields.tsx';
import { PersonSelector } from '@/entities/PersonSelector/PersonSelector.tsx';

import { TMeetingRoomForm } from '@/features/NewBooking/useMeetingRoomForm.tsx';

import { LabelInput, SwitchSelector } from '@/shared/uikit/components/input';

type Props = {
	form: UseFormReturnType<TMeetingRoomForm>;
	isAvailableToExternalMeeting?: boolean;
	isExternalMeeting?: boolean;
	isServiceRequired?: boolean;
	isShowCarNumberField?: boolean;
	onExternalMeeting: () => void;
	onServiceRequired: () => void;
	onShowCarNumberField: () => void;
};

export const BookingMeetingRoomFields = ({
	form,
	isAvailableToExternalMeeting,
	isExternalMeeting = false,
	isServiceRequired = false,
	isShowCarNumberField = false,
	onExternalMeeting,
	onServiceRequired,
	onShowCarNumberField,
}: Props) => {
	return (
		<>
			{isAvailableToExternalMeeting && (
				<SwitchSelector
					name="Внешняя встреча"
					description="Бронирование внешней встречи"
					checked={isExternalMeeting}
					onChange={onExternalMeeting}
				/>
			)}

			{isExternalMeeting && (
				<SwitchSelector
					name="Разрешить гостям регистрацию автомобиля"
					checked={isShowCarNumberField}
					onChange={onShowCarNumberField}
				/>
			)}

			{/*{isExternalMeeting && (*/}
			{/*	<SwitchSelector*/}
			{/*		name="Требуется обслуживание"*/}
			{/*		checked={isServiceRequired}*/}
			{/*		onChange={onServiceRequired}*/}
			{/*	/>*/}
			{/*)}*/}

			<PersonSelector {...form.getInputProps('additional_clients_id')} />
			{isExternalMeeting && (
				<>
					<LabelInput
						label="Тема"
						placeholder="Указать тему"
						{...form.getInputProps('appointment_subject')}
					/>
					<LabelInput
						label="Описание встречи"
						placeholder="Указать описание"
						multiple
						{...form.getInputProps('appointment_body')}
					/>
					<GuestFields form={form} />
				</>
			)}
		</>
	);
};
